import { Action, createSlice, PayloadAction } from "@reduxjs/toolkit/react"
import { DateTime } from "luxon"

const initial = {
	overriddenDate: "",
	rdsKeepAliveEnabled: ""
}

export const environmentSlice = createSlice({
	name: "environment",
	initialState: initial,
	reducers: {
		setOverrideDate: (
			state,
			action: PayloadAction<DateTime<true> | undefined>
		) => {
			state.overriddenDate =
				!action.payload || action.payload?.equals(DateTime.utc())
					? ""
					: action.payload.toISODate()
		},
		setRdsKeepAliveEnabled: (state, _: Action) => {
			state.rdsKeepAliveEnabled = DateTime.utc().toString()
		}
	},
	selectors: {
		rdsKeepAliveEnabled: (slice) =>
			DateTime.fromISO(slice.rdsKeepAliveEnabled) >
			DateTime.utc().minus({ hours: 12 }),
		overriddenDateRaw: (slice) => slice.overriddenDate,
		overriddenDate: (slice) => {
			const overriddenDate = slice.overriddenDate
				? DateTime.fromISO(slice.overriddenDate)
				: undefined

			if (!overriddenDate || !overriddenDate.isValid) {
				return undefined
			}

			return overriddenDate
		}
	}
})

export default environmentSlice
